import { render, staticRenderFns } from "./RewardWheelHeader.vue?vue&type=template&id=65bff6c6&"
import script from "./RewardWheelHeader.vue?vue&type=script&lang=js&"
export * from "./RewardWheelHeader.vue?vue&type=script&lang=js&"
import style0 from "./RewardWheelHeader.vue?vue&type=style&index=0&id=65bff6c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports